import { FC, Fragment, JSX } from 'react';
import { Box, Button, Typography } from '@mui/material';
import { AddRounded as AddRoundedIcon } from '@mui/icons-material';
//components
import { useNavigate } from 'react-router-dom';
import CapsulePriceTable from './CapsulePriceTable';
// constant, styles, reducer, graphql
import { flexCenterBetween } from 'styles/commonComponentStyle';
import { ADD_CAPSULE_PRICE_ROUTE, ADD_NEW_TEXT, CAPSULE_PRICE_TEXT } from 'constants/index';

const CapsulePrice: FC = (): JSX.Element => {
  const navigate = useNavigate();

  return (
    <Fragment>
      <Box sx={flexCenterBetween}>
        <Typography variant="h5">{CAPSULE_PRICE_TEXT}</Typography>
        <Button
          variant="contained"
          color="primary"
          onClick={() => navigate(ADD_CAPSULE_PRICE_ROUTE)}
          startIcon={<AddRoundedIcon />}>
          {ADD_NEW_TEXT}
        </Button>
      </Box>
      <CapsulePriceTable />
    </Fragment>
  );
};

export default CapsulePrice;
